import { ModalMovState } from "../states/ModalMovState";
import { ReducerAction } from '../ReducerAction';
import { ActionType } from "../ActionsTypes";


export const modalMovReducer = (state = new ModalMovState({}), action: ReducerAction) => {

    switch (action.type) {

        case ActionType.MODALMOV_SETUP:
            return new ModalMovState({
                ...action.payload
            })
        case ActionType.MODALMOV_SET_DATA:
            return new ModalMovState({
                ...state,
                show: true,
                data: action.payload ?? [],
                isCustom: false
            });

        case ActionType.MODALMOV_SET_DATA_ALL:
            return new ModalMovState({
                ...state,
                dataAll: action.payload ?? [],
            });

        case ActionType.MODALMOV_SET_DATE:
            return new ModalMovState({
                ...state,
                show: true,
                date: action.payload ?? new Date()
            });

        case ActionType.MODALMOV_SET_DATE_END:
            return new ModalMovState({
                ...state,
                show: true,
                dateEnd: action.payload
            });

        case ActionType.MODALMOV_SET_PAGE:
            return new ModalMovState({
                ...state,
                show: true,
                page: action.payload
            });

        case ActionType.MODALMOV_SET_QUERYTYPE:
            return new ModalMovState({
                ...state,
                show: true,
                queryType: action.payload
            });

        case ActionType.MODALMOV_SET_TOKEN:
            return new ModalMovState({
                ...state,
                token: action.payload
            });

        case ActionType.MODALMOV_SET_CUSTOM:
            return new ModalMovState({
                ...state,
                isCustom: action.payload
            });

        case ActionType.MODALMOV_RESET:
            return new ModalMovState({});

        default:
            return state;
    }
}
